import { createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

import { updateDraft } from './draft'

const STARTING_TASK_VALS = {
  date: moment(),
  status: '',
  type: '',
  primary: '',
  watchers: [],
  title: '',
  content: '',
  file: null
}

const initialState = {
  message: '',
  email: '',
  subject: '',
  file: [],
  phoneNumber: '',
  taskVals: STARTING_TASK_VALS,
  undoText: '',
  isReplacedString: false,
  hasUndoReplacedString: false
}

const chatControlsSlice = createSlice({
  name: 'chatControls',
  initialState,
  reducers: {
    reset: () => {
      return initialState
    },

    resetDraft: state => {
      state.message = ''
      state.file = []
    },

    resetExtra: state => {
      state.email = ''
      state.phoneNumber = ''
    },

    resetTask: state => {
      state.taskVals = STARTING_TASK_VALS
    },

    clearData: state => {
      state.message = ''
      state.subject = ''
    },

    setValue: (state, { payload }) => {
      const { key, value } = payload
      state[key] = value
    },

    loadDraft: (state, { payload }) => {
      const { message, file } = payload
      return { ...initialState, message, file }
    }
  }
})

export const {
  reset,
  resetDraft,
  resetExtra,
  resetTask,
  clearData,
  loadDraft
} = chatControlsSlice.actions
const { setValue } = chatControlsSlice.actions

export const updateValue = (key, value) => {
  return async (dispatch, getState) => {
    let newValue = value

    if (typeof value === 'function') {
      const oldValue = getState().chatControls[key]
      newValue = value(oldValue)
    }

    dispatch(setValue({ key, value: newValue }))
    if (key === 'message') {
      dispatch(updateDraft(newValue))
    }
  }
}

export const selectChatControls = state => state.chatControls

export default chatControlsSlice.reducer
